import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 105 60"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#E1E1E1\" d=\"M.5.661h104v58.361H.5z\"></path><path fill=\"#B3B3B3\" fill-rule=\"evenodd\" d=\"M43.6 19.761a2.8 2.8 0 0 0-2.8 2.8v14a2.8 2.8 0 0 0 2.8 2.8h16.8a2.8 2.8 0 0 0 2.8-2.8v-14a2.8 2.8 0 0 0-2.8-2.8zm16.8 16.8H43.6l5.6-11.2 4.2 8.4 2.8-5.6z\" clip-rule=\"evenodd\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M.5.661h104v58.361H.5z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }